<template>
  <div :class="[
    'section-statistics__tab section-statistics__tab--unsubscribes',
    'section-statistics__row',
    {'section-statistics__row--long-table-mode': longTablePart}
  ]">
    <!-- <CirclePart
      :isLoading="isLoading.additional"
      :isError="isError.additional"
      :value="formedInfo"
      class="unsubscribes__circle-part"
    /> -->
    <BasicTable
      v-if="commType === 'email'"
      :isLoading="$store.state.stat.loadings.unsubscribe"
      :isError="$store.state.stat.errors.unsubscribe"
      :value="formedInfo"
    />
    <div class="section-statistics__column">
      <BarPart />
      <TablePart />
    </div>
  </div>
</template>

<script>
import tabs_mixin from "@/components/statistics/stats/tabs/tabs_mixin";

// import CirclePart from "./CirclePart.vue";
import TablePart from "./TablePart2.vue";
import BarPart from "./BarPart.vue";
import BasicTable from "./TablePart.vue";
export default {
  mixins: [tabs_mixin],

  components: {
    // CirclePart,
    TablePart,
    BarPart,
    BasicTable,
  },

  computed: {
    formedInfo() {
      const { records } = this.$store.getters.statUnsubscribe;
      if (records) {
        const timeZoneOffset = new Date().getTimezoneOffset();
        records.forEach((item, index) => {
          records[index].date = item.date - timeZoneOffset * 60;
        });
      }
      return records || [];
    }
  }
}
</script>

<style lang="scss" scoped>
.section-statistics__tab--unsubscribes {
  display: flex;
  gap: 10px;
  // flex-direction: column;
  &.section-statistics__row--long-table-mode {
    flex-direction: row-reverse;
  }
  .cm-stat-table-container {
    height: auto;
    margin-top: 0 !important;
  }

  .word-no-wrap {
    white-space: nowrap;
  }

  .unsubscribes__circle-part {
    margin-bottom: 25px;
  }

  .cm-state-card--grouped-bar {
    margin-bottom: 35px;
  }

  .cm-donut-card {
    padding: 0 20px;
    .legend-name-td {
      padding-right: 15px;
    }
  }
}
.section-statistics__column {
  display: flex;
  flex-direction: column;
}
::v-deep.statistics-group-table {
  width: 670px;
}
</style>
